<template>
  <div>
    <el-tabs v-model="activeIdx" class="main-tabs" @tab-change="tabChange">
      <el-tab-pane label="部门" name="0"></el-tab-pane>
      <el-tab-pane label="岗位级别" name="1"></el-tab-pane>
      <el-tab-pane label="饭补级别" name="2"></el-tab-pane>
      <el-tab-pane label="车补" name="3"></el-tab-pane>
      <el-tab-pane label="住宿" name="4"></el-tab-pane>
      <el-tab-pane label="社保级别" name="5"></el-tab-pane>
      <el-tab-pane label="绩效扣款等级系数" name="6"></el-tab-pane>
    </el-tabs>
    <div class="level-pane" v-if="activeIdx == 0">
      <info-change-department :info="info"
                              @onSave="handleSave"
                              @onChange="handleChange"
      ></info-change-department>
    </div>
    <div class="level-pane" v-if="activeIdx == 1">
      <info-change-job :info="info"
                       @onSave="handleSave"
                       @onChange="handleChange"
      ></info-change-job>
    </div>
    <div class="level-pane" v-if="activeIdx == 2">
      <info-change-meal :info="info"
                        @onSave="handleSave"
                        @onChange="handleChange"
      ></info-change-meal>
    </div>
    <div class="level-pane" v-if="activeIdx == 3">
      <info-change-car :info="info"
                       @onSave="handleSave"
                       @onChange="handleChange"
      ></info-change-car>
    </div>
    <div class="level-pane" v-if="activeIdx == 4">
      <info-change-accommodation :info="info"
                                 @onSave="handleSave"
                                 @onChange="handleChange"
      ></info-change-accommodation>
    </div>
    <div class="level-pane" v-if="activeIdx == 5">
      <info-change-insure :info="info"
                             @onSave="handleSave"
                             @onChange="handleChange"
      ></info-change-insure>
    </div>
    <div class="level-pane" v-if="activeIdx == 6">
      <info-change-performance :info="info"
                               @onSave="handleSave"
                               @onChange="handleChange"
      ></info-change-performance>
    </div>
  </div>
</template>

<script setup>
	import {
		reactive,
		ref,
		onMounted,
        defineProps,
        defineEmits,
        watch
	} from "vue";
  import infoChangeJob from "./infoChangeJob.vue";
  import infoChangeDepartment from "./infoChangeDepartment.vue";
  import infoChangeMeal from "./infoChangeMeal.vue";
  import infoChangeCar from "./infoChangeCar.vue";
  import infoChangeAccommodation from "./infoChangeAccommodation.vue";
  import infoChangeInsure from "./infoChangeInsure.vue";
  import infoChangePerformance from "./infoChangePerformance.vue";

  const activeIdx = ref("0");
  const tabChange = (name) => {
    activeIdx.value = name;
  };
  const info = ref({});

  const props = defineProps(['info'])
  watch(props, (newVal, oldVal) => {
    console.log(newVal.info)
    if (newVal.info) {
      info.value = JSON.parse(JSON.stringify(newVal.info))
    }
  }, {immediate: true, deep: true})

	onMounted(() => {
	});

  const emit = defineEmits(['onSave'])
  const handleSave = (row) => {
    emit('onSave', row)
  }
  const handleChange = () => {
    emit('onChange')
  }
</script>
<style lang="scss" scoped>
	.el-form{
		// max-height: 65vh;
		// overflow-y: auto;
	}
	::v-deep .el-form-item__label {
		align-items: center;
		line-height: 16px;
		padding: 0 12px 0 4px;
		text-align: right;
	}
</style>
